export default "__VITE_ASSET__C_zgWK0S__"